import $ from 'jquery'

const logAndSendEvent = (name, parameters) => {
  console.log(`gtag event ${name}: ${JSON.stringify(parameters)}`)
  gtag('event', name, parameters)
}

const safelyGetData = (json) => {
  let data
  try {
    data = JSON.parse(json)
  } catch (e) {
    console.error(`Error parsing "${json}" as JSON: ${e.message}`)
    return null
  }
  return data
}

const variationToItem = (variation) => {
  let price = parseFloat(variation.price)
  if (Number.isNaN(price)) {
    console.error(
      `Error parsing variation.price ${
        variation.price
      } to float, variation = ${JSON.stringify(variation)}`
    )
    price = 0
  }
  if (variation.quantity) {
    let quantity = parseFloat(variation.quantity)
    if (Number.isNaN(quantity)) {
      console.error(
        `Error parsing variation.quantity ${
          variation.quantity
        } to float, variation = ${JSON.stringify(variation)}`
      )
      quantity = 0
    }
    return {
      ...variation,
      price,
      quantity,
    }
  }
  return {
    ...variation,
    price,
  }
}

const track = () => {
  // PB Daily "More From" teaser
  const $moreFromPaperBrigadeAnalytics = $(
    '.field--name-field-more-from-product .more-from-paper-brigade-analytics'
  )
  if (
    $moreFromPaperBrigadeAnalytics &&
    $moreFromPaperBrigadeAnalytics.length === 1
  ) {
    const data = safelyGetData($moreFromPaperBrigadeAnalytics.text())
    if (data && data.price) {
      const items = [variationToItem(data)]
      logAndSendEvent('view_promotion', {
        creative_slot: 'More From',
        items,
        location_id: window.location.pathname,
      })
      $('.field--name-field-more-from-product .link').one('click', () => {
        logAndSendEvent('select_promotion', {
          creative_slot: 'More From',
          items,
          location_id: window.location.pathname,
        })
      })
    }
  }

  // PDP
  const $commerceProductFullAnalytics = $('.commerce-product-full-analytics')
  if (
    $commerceProductFullAnalytics &&
    $commerceProductFullAnalytics.length === 1
  ) {
    const data = safelyGetData($commerceProductFullAnalytics.text())
    if (
      data &&
      data.variations &&
      data.variations.length > 0 &&
      data.variations[0].price
    ) {
      // view_item for initial page load
      let item = variationToItem(data.variations[0])
      logAndSendEvent('view_item', {
        currency: item.currency,
        items: [item],
        value: item.price,
      })
      // Rig up clicks on Add to Cart button
      let $addToCartButton = $('.button--add-to-cart')
      if ($addToCartButton && $addToCartButton.length === 1) {
        $addToCartButton.one('click', () => {
          logAndSendEvent('add_to_cart', {
            currency: item.currency,
            items: [item],
            value: item.price,
          })
        })
      }
      Drupal.behaviors.jbcTrack = {
        attach: (context) => {
          // When 'Shipping' select is changed, send view_item for variant
          if (context.id.indexOf('commerce-product-add-to-cart-form') === 0) {
            const $select = $(context).find('select')
            if ($select && $select.length === 1) {
              const select = parseInt($select.val(), 10)
              if (Number.isNaN(select)) {
                console.error(`Error parsing ${select} to int`)
                return
              }
              const index = select - 1
              const variation = data.variations[index]
              if (!variation) {
                console.error(
                  `Could not find data.variations for index ${index}, data.variations.length = ${data.variations.length}`
                )
                return
              }
              item = variationToItem(variation)
              logAndSendEvent('view_item', {
                currency: item.currency,
                items: [item],
                value: item.price,
              })
              // Start tracking clicks on replaced Add to Cart button
              $addToCartButton = $('.button--add-to-cart')
              if ($addToCartButton && $addToCartButton.length === 1) {
                $addToCartButton.one('click', () => {
                  logAndSendEvent('add_to_cart', {
                    currency: item.currency,
                    items: [item],
                    value: item.price,
                  })
                })
              }
            }
          }
        },
      }
    }
  }

  // Cart
  if (drupalSettings.cartAnalytics && drupalSettings.cartAnalytics.variations) {
    const items = drupalSettings.cartAnalytics.variations.map(variationToItem)
    if (items.length > 0) {
      const currency = items[0].currency
      let value = 0
      if (currency) {
        items.forEach((item) => {
          value += item.price * item.quantity
        })
        logAndSendEvent('view_cart', {
          currency,
          items,
          value,
        })
        $('#edit-checkout').one('click', () => {
          logAndSendEvent('begin_checkout', {
            currency,
            items,
            value,
          })
        })
      }
    }
  }

  // Review
  if (
    drupalSettings.reviewAnalytics &&
    drupalSettings.reviewAnalytics.variations
  ) {
    const items = drupalSettings.reviewAnalytics.variations.map(variationToItem)
    if (items.length > 0) {
      const currency = items[0].currency
      let value = 0
      if (currency) {
        items.forEach((item) => {
          value += item.price * item.quantity
        })
        logAndSendEvent('add_payment_info', {
          currency,
          items,
          payment_type: drupalSettings.reviewAnalytics.paymentType,
          value,
        })
      }
    }
  }

  // Purchase
  if (
    drupalSettings.purchaseAnalytics &&
    drupalSettings.purchaseAnalytics.variations
  ) {
    const analytics = drupalSettings.purchaseAnalytics
    const items = analytics.variations.map(variationToItem)
    if (items.length > 0) {
      const currency = items[0].currency
      let value = 0
      if (currency) {
        items.forEach((item) => {
          value += item.price * item.quantity
        })
        const parameters = {
          currency,
          items,
          transaction_id: analytics.transaction_id,
          value,
        }
        if (analytics.coupon) {
          parameters.coupon = analytics.coupon
        }
        if (analytics.diff > 5) {
          console.warn(
            `diff = ${
              analytics.diff
            }, DID NOT SEND gtag event purchase: ${JSON.stringify(parameters)}`
          )
        } else {
          logAndSendEvent('purchase', parameters)
        }
      }
    }
  }
}

export default track
